import React, { useEffect, useState } from 'react'
import {
  MdCampaign,
  MdClose,
  MdSend,
  MdStop,
  MdOutlineRepeat,
  MdOutlineTimer,
  MdOutlineInfo,
} from 'react-icons/md'
import { makeNotice, noticeLabel } from './liveMsg'

// Reception se likha hua message Display screen bolti hai.
// Hindi text tabhi theek bolega jab Display device par Hindi voice install ho —
// warna staff English (Latin) me likhe: "Kripya apni baari ka intezaar karein".
const PRESETS = {
  'hi-IN': [
    'कृपया अपनी बारी का इंतज़ार करें।',
    'कृपया लाइन में खड़े रहें।',
    'कृपया मोबाइल साइलेंट पर रखें।',
    'एक इमरजेंसी केस चल रहा है, कृपया थोड़ा इंतज़ार करें।',
    'आज की ओ पी डी अब बंद होने वाली है।',
  ],
  'en-IN': [
    'Please wait for your turn.',
    'Please stand in the queue.',
    'Kindly keep your mobile on silent.',
    'An emergency case is in progress, please wait.',
    'Today OPD is closing soon.',
  ],
}

const LANGS = [
  { id: 'hi-IN', label: 'हिंदी' },
  { id: 'en-IN', label: 'English' },
]

const REPEATS = [
  { id: 0, label: 'One time' },
  { id: 1, label: '1 min' },
  { id: 2, label: '2 min' },
  { id: 5, label: '5 min' },
  { id: 10, label: '10 min' },
  { id: 15, label: '15 min' },
  { id: 30, label: '30 min' },
]

const STOPS = [
  { id: 0, label: 'Till I stop' },
  { id: 15, label: '15 min' },
  { id: 30, label: '30 min' },
  { id: 60, label: '1 hour' },
]

export default function AnnouncePopUp({ isOpen, setIsOpen, onSend, onStop, active, loding }) {
  const [lang, setLang] = useState('hi-IN')
  const [text, setText] = useState('')
  const [everyMin, setEveryMin] = useState(0)
  const [stopAfterMin, setStopAfterMin] = useState(0)
  const [error, setError] = useState('')

  useEffect(() => {
    if (isOpen) setError('')
  }, [isOpen])

  if (!isOpen) return null

  const send = () => {
    const clean = text.trim()
    if (!clean) {
      setError('Announcement likhein ya niche se koi message chunein.')
      return
    }
    onSend(makeNotice({ text: clean, lang, everyMin, stopAfterMin: everyMin ? stopAfterMin : 0 }))
    setIsOpen(false)
  }

  const Chip = ({ on, children, ...rest }) => (
    <button
      type="button"
      {...rest}
      className={`rounded-lg px-3 py-2 text-xs font-semibold transition active:scale-95 sm:text-sm ${on
        ? 'bg-brand-500 text-white shadow'
        : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`}
    >
      {children}
    </button>
  )

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center bg-black/40 p-0 sm:items-center sm:p-4">
      <div className="max-h-[92vh] w-full overflow-y-auto rounded-t-2xl bg-white shadow-xl sm:max-w-lg sm:rounded-2xl">

        {/* header */}
        <div className="flex items-center justify-between border-b border-gray-100 px-4 py-3">
          <span className="flex items-center gap-2 font-semibold text-gray-800">
            <MdCampaign className="text-xl text-brand-500" /> Announcement
          </span>
          <button
            type="button"
            onClick={() => setIsOpen(false)}
            className="grid h-8 w-8 place-items-center rounded-lg text-gray-400 transition hover:bg-gray-100 hover:text-gray-600"
          >
            <MdClose className="text-lg" />
            <span className="sr-only">Close</span>
          </button>
        </div>

        <div className="flex flex-col gap-4 px-4 py-4">

          {/* abhi chal rahi announcement */}
          {active &&
            <div className="flex items-start gap-2 rounded-xl border border-amber-200 bg-amber-50 px-3 py-2.5">
              <MdCampaign className="mt-0.5 shrink-0 text-lg text-amber-600" />
              <div className="flex-1">
                <div className="text-sm font-semibold text-amber-900">{active.text}</div>
                <div className="text-xs text-amber-700">{noticeLabel(active)}</div>
              </div>
              <button
                type="button"
                onClick={onStop}
                className="inline-flex shrink-0 items-center gap-1 rounded-lg bg-red-500 px-3 py-2 text-xs font-semibold text-white transition hover:bg-red-600 active:scale-95"
              >
                <MdStop className="text-base" /> Stop
              </button>
            </div>
          }

          {/* language */}
          <div>
            <div className="mb-1.5 text-[11px] font-semibold uppercase tracking-wide text-gray-400">Language</div>
            <div className="flex gap-1 rounded-xl bg-gray-100 p-1">
              {LANGS.map(({ id, label }) => (
                <button
                  key={id}
                  type="button"
                  onClick={() => setLang(id)}
                  aria-pressed={lang === id}
                  className={`flex-1 rounded-lg px-3 py-2 text-sm font-semibold transition ${lang === id
                    ? 'bg-brand-500 text-white shadow'
                    : 'text-gray-500 hover:bg-white hover:text-gray-700'}`}
                >
                  {label}
                </button>
              ))}
            </div>
          </div>

          {/* text */}
          <div>
            <div className="mb-1.5 text-[11px] font-semibold uppercase tracking-wide text-gray-400">Message</div>
            <textarea
              rows={3}
              maxLength={300}
              value={text}
              onChange={(e) => { setText(e.target.value); setError('') }}
              placeholder={lang === 'hi-IN' ? 'जो बोलना है वो यहाँ लिखें...' : 'Type what the display should say...'}
              className="block w-full resize-none rounded-lg border border-gray-300 bg-gray-50 p-3 text-sm text-gray-900 outline-none focus:border-blue-500 focus:ring-blue-500"
            />
            <div className="mt-1 flex items-center justify-between">
              {error
                ? <span className="text-xs font-medium text-red-500">{error}</span>
                : <span className="text-xs text-gray-400">Display screen ye line bolegi.</span>}
              <span className="text-xs text-gray-400">{text.length}/300</span>
            </div>

            <div className="mt-2 flex flex-wrap gap-1.5">
              {PRESETS[lang].map((p, i) => (
                <button
                  key={i}
                  type="button"
                  onClick={() => { setText(p); setError('') }}
                  className="rounded-full border border-gray-200 bg-gray-50 px-3 py-1.5 text-xs text-gray-600 transition hover:border-brand-500 hover:text-brand-600 active:scale-95"
                >
                  {p}
                </button>
              ))}
            </div>
          </div>

          {/* repeat */}
          <div>
            <div className="mb-1.5 flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wide text-gray-400">
              <MdOutlineRepeat className="text-sm" /> Repeat
            </div>
            <div className="flex flex-wrap gap-1.5">
              {REPEATS.map(({ id, label }) => (
                <Chip key={id} on={everyMin === id} onClick={() => setEveryMin(id)}>{label}</Chip>
              ))}
            </div>
          </div>

          {/* kab tak (sirf repeat wali me) */}
          {everyMin > 0 &&
            <div>
              <div className="mb-1.5 flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wide text-gray-400">
                <MdOutlineTimer className="text-sm" /> Kab tak chale
              </div>
              <div className="flex flex-wrap gap-1.5">
                {STOPS.map(({ id, label }) => (
                  <Chip key={id} on={stopAfterMin === id} onClick={() => setStopAfterMin(id)}>{label}</Chip>
                ))}
              </div>
            </div>
          }

          <div className="flex items-start gap-2 rounded-lg bg-blue-50 px-3 py-2 text-xs text-blue-800">
            <MdOutlineInfo className="mt-0.5 shrink-0 text-sm" />
            <span>
              Repeat wali announcement Display screen apne aap dohrati hai — Reception band kar sakta hai kabhi bhi.
              Hindi voice install na ho to Hindi lines "Kripya intezaar karein" style me likhein.
            </span>
          </div>
        </div>

        {/* footer */}
        <div className="flex gap-2 border-t border-gray-100 px-4 py-3">
          <button
            type="button"
            onClick={() => setIsOpen(false)}
            className="flex-1 rounded-xl bg-gray-100 px-4 py-3 text-sm font-semibold text-gray-600 transition hover:bg-gray-200 active:scale-95"
          >
            Cancel
          </button>
          <button
            type="button"
            disabled={loding}
            onClick={send}
            className="flex flex-1 items-center justify-center gap-2 rounded-xl bg-brand-500 px-4 py-3 text-sm font-semibold text-white shadow transition hover:bg-brand-600 focus:ring-2 focus:ring-brand-500 active:scale-95 disabled:opacity-60"
          >
            <MdSend className="text-base" /> Announce
          </button>
        </div>
      </div>
    </div>
  )
}